import styled from 'styled-components/macro';
import tw from 'tailwind.macro';
import { h3Style } from '../../../components/H3';

const FaqH2 = styled.h2`
  ${h3Style}
  ${tw`text-left sm:mt-abs5
    sm:mb-gutter px-def`};
`;
export default FaqH2;
